module.exports = __webpack_public_path__ + "static/icons/icon-location-c19e8428e236f01d48c841c3d1cf247b.svg";